// Les événements sont chargés côté client ; leurs métadonnées publiques sont
// déjà préfetchées par le routeur SSR, ou fournies avec la page personnalisée.
export function eventMetadata(context) {
    if (context?.page?.type !== "EVENT") return {}
    return {...(context.data?.[0]?.meta || {}), ...(context.page.meta || {})}
}

export function eventImage(context, image) {
    return image || eventMetadata(context).image || null
}
